import { Color as pt } from "./index.es247.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function Xn() {
}
const Yn = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function I(t) {
  return t == null;
}
function P(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const n = Object.prototype.toString.call(t);
  return n.slice(0, 7) === "[object" && n.slice(-6) === "Array]";
}
function x(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function dt(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function Zn(t, n) {
  return dt(t) ? t : n;
}
function _(t, n) {
  return typeof t > "u" ? n : t;
}
const te = (t, n) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / n, Rt = (t, n) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * n : +t;
function ne(t, n, e) {
  if (t && typeof t.call == "function")
    return t.apply(e, n);
}
function ee(t, n, e, o) {
  let r, i, a;
  if (P(t))
    for (i = t.length, r = 0; r < i; r++)
      n.call(e, t[r], r);
  else if (x(t))
    for (a = Object.keys(t), i = a.length, r = 0; r < i; r++)
      n.call(e, t[a[r]], a[r]);
}
function oe(t, n) {
  let e, o, r, i;
  if (!t || !n || t.length !== n.length)
    return !1;
  for (e = 0, o = t.length; e < o; ++e)
    if (r = t[e], i = n[e], r.datasetIndex !== i.datasetIndex || r.index !== i.index)
      return !1;
  return !0;
}
function z(t) {
  if (P(t))
    return t.map(z);
  if (x(t)) {
    const n = /* @__PURE__ */ Object.create(null), e = Object.keys(t), o = e.length;
    let r = 0;
    for (; r < o; ++r)
      n[e[r]] = z(t[e[r]]);
    return n;
  }
  return t;
}
function gt(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function Wt(t, n, e, o) {
  if (!gt(t))
    return;
  const r = n[t], i = e[t];
  x(r) && x(i) ? E(r, i, o) : n[t] = z(i);
}
function E(t, n, e) {
  const o = P(n) ? n : [
    n
  ], r = o.length;
  if (!x(t))
    return t;
  e = e || {};
  const i = e.merger || Wt;
  let a;
  for (let s = 0; s < r; ++s) {
    if (a = o[s], !x(a))
      continue;
    const c = Object.keys(a);
    for (let l = 0, u = c.length; l < u; ++l)
      i(c[l], t, a, e);
  }
  return t;
}
function Bt(t, n) {
  return E(t, n, {
    merger: At
  });
}
function At(t, n, e) {
  if (!gt(t))
    return;
  const o = n[t], r = e[t];
  x(o) && x(r) ? Bt(o, r) : Object.prototype.hasOwnProperty.call(n, t) || (n[t] = z(r));
}
const tt = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function Dt(t) {
  const n = t.split("."), e = [];
  let o = "";
  for (const r of n)
    o += r, o.endsWith("\\") ? o = o.slice(0, -1) + "." : (e.push(o), o = "");
  return e;
}
function Nt(t) {
  const n = Dt(t);
  return (e) => {
    for (const o of n) {
      if (o === "")
        break;
      e = e && e[o];
    }
    return e;
  };
}
function Lt(t, n) {
  return (tt[n] || (tt[n] = Nt(n)))(t);
}
function yt(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const re = (t) => typeof t < "u", H = (t) => typeof t == "function", ie = (t, n) => {
  if (t.size !== n.size)
    return !1;
  for (const e of t)
    if (!n.has(e))
      return !1;
  return !0;
};
function ae(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const m = Math.PI, M = 2 * m, zt = M + m, F = Number.POSITIVE_INFINITY, Et = m / 180, w = m / 2, k = m / 4, nt = m * 2 / 3, bt = Math.log10, et = Math.sign;
function mt(t, n, e) {
  return Math.abs(t - n) < e;
}
function se(t) {
  const n = Math.round(t);
  t = mt(t, n, t / 1e3) ? n : t;
  const e = Math.pow(10, Math.floor(bt(t))), o = t / e;
  return (o <= 1 ? 1 : o <= 2 ? 2 : o <= 5 ? 5 : 10) * e;
}
function ce(t) {
  const n = [], e = Math.sqrt(t);
  let o;
  for (o = 1; o < e; o++)
    t % o === 0 && (n.push(o), n.push(t / o));
  return e === (e | 0) && n.push(e), n.sort((r, i) => r - i).pop(), n;
}
function Ht(t) {
  return typeof t == "symbol" || typeof t == "object" && t !== null && !(Symbol.toPrimitive in t || "toString" in t || "valueOf" in t);
}
function le(t) {
  return !Ht(t) && !isNaN(parseFloat(t)) && isFinite(t);
}
function ue(t, n) {
  const e = Math.round(t);
  return e - n <= t && e + n >= t;
}
function fe(t, n, e) {
  let o, r, i;
  for (o = 0, r = t.length; o < r; o++)
    i = t[o][e], isNaN(i) || (n.min = Math.min(n.min, i), n.max = Math.max(n.max, i));
}
function he(t) {
  return t * (m / 180);
}
function pe(t) {
  return t * (180 / m);
}
function de(t) {
  if (!dt(t))
    return;
  let n = 1, e = 0;
  for (; Math.round(t * n) / n !== t; )
    n *= 10, e++;
  return e;
}
function ge(t, n) {
  const e = n.x - t.x, o = n.y - t.y, r = Math.sqrt(e * e + o * o);
  let i = Math.atan2(o, e);
  return i < -0.5 * m && (i += M), {
    angle: i,
    distance: r
  };
}
function ot(t, n) {
  return Math.sqrt(Math.pow(n.x - t.x, 2) + Math.pow(n.y - t.y, 2));
}
function Ft(t, n) {
  return (t - n + zt) % M - m;
}
function v(t) {
  return (t % M + M) % M;
}
function Qt(t, n, e, o) {
  const r = v(t), i = v(n), a = v(e), s = v(i - r), c = v(a - r), l = v(r - i), u = v(r - a);
  return r === i || r === a || o && i === a || s > c && l < u;
}
function J(t, n, e) {
  return Math.max(n, Math.min(e, t));
}
function ye(t) {
  return J(t, -32768, 32767);
}
function qt(t, n, e, o = 1e-6) {
  return t >= Math.min(n, e) - o && t <= Math.max(n, e) + o;
}
function xt(t, n, e) {
  e = e || ((a) => t[a] < n);
  let o = t.length - 1, r = 0, i;
  for (; o - r > 1; )
    i = r + o >> 1, e(i) ? r = i : o = i;
  return {
    lo: r,
    hi: o
  };
}
const B = (t, n, e, o) => xt(t, e, o ? (r) => {
  const i = t[r][n];
  return i < e || i === e && t[r + 1][n] === e;
} : (r) => t[r][n] < e), be = (t, n, e) => xt(t, e, (o) => t[o][n] >= e), Mt = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function me(t, n) {
  if (t._chartjs) {
    t._chartjs.listeners.push(n);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        n
      ]
    }
  }), Mt.forEach((e) => {
    const o = "_onData" + yt(e), r = t[e];
    Object.defineProperty(t, e, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const a = r.apply(this, i);
        return t._chartjs.listeners.forEach((s) => {
          typeof s[o] == "function" && s[o](...i);
        }), a;
      }
    });
  });
}
function xe(t, n) {
  const e = t._chartjs;
  if (!e)
    return;
  const o = e.listeners, r = o.indexOf(n);
  r !== -1 && o.splice(r, 1), !(o.length > 0) && (Mt.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function Me(t) {
  const n = new Set(t);
  return n.size === t.length ? t : Array.from(n);
}
const $t = (function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
})();
function we(t, n) {
  let e = [], o = !1;
  return function(...r) {
    e = r, o || (o = !0, $t.call(window, () => {
      o = !1, t.apply(n, e);
    }));
  };
}
function ve(t, n) {
  let e;
  return function(...o) {
    return n ? (clearTimeout(e), e = setTimeout(t, n, o)) : t.apply(this, o), n;
  };
}
const ke = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", _e = (t, n, e) => t === "start" ? n : t === "end" ? e : (n + e) / 2, Oe = (t, n, e, o) => t === (o ? "left" : "right") ? e : t === "center" ? (n + e) / 2 : n;
function Pe(t, n, e) {
  const o = n.length;
  let r = 0, i = o;
  if (t._sorted) {
    const { iScale: a, vScale: s, _parsed: c } = t, l = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null, u = a.axis, { min: p, max: d, minDefined: g, maxDefined: y } = a.getUserBounds();
    if (g) {
      if (r = Math.min(
        // @ts-expect-error Need to type _parsed
        B(c, u, p).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        e ? o : B(n, u, a.getPixelForValue(p)).lo
      ), l) {
        const h = c.slice(0, r + 1).reverse().findIndex((f) => !I(f[s.axis]));
        r -= Math.max(0, h);
      }
      r = J(r, 0, o - 1);
    }
    if (y) {
      let h = Math.max(
        // @ts-expect-error Need to type _parsed
        B(c, a.axis, d, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        e ? 0 : B(n, u, a.getPixelForValue(d), !0).hi + 1
      );
      if (l) {
        const f = c.slice(h - 1).findIndex((b) => !I(b[s.axis]));
        h += Math.max(0, f);
      }
      i = J(h, r, o) - r;
    } else
      i = o - r;
  }
  return {
    start: r,
    count: i
  };
}
function Te(t) {
  const { xScale: n, yScale: e, _scaleRanges: o } = t, r = {
    xmin: n.min,
    xmax: n.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!o)
    return t._scaleRanges = r, !0;
  const i = o.xmin !== n.min || o.xmax !== n.max || o.ymin !== e.min || o.ymax !== e.max;
  return Object.assign(o, r), i;
}
const A = (t) => t === 0 || t === 1, rt = (t, n, e) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - n) * M / e)), it = (t, n, e) => Math.pow(2, -10 * t) * Math.sin((t - n) * M / e) + 1, K = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * w) + 1,
  easeOutSine: (t) => Math.sin(t * w),
  easeInOutSine: (t) => -0.5 * (Math.cos(m * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => A(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => A(t) ? t : rt(t, 0.075, 0.3),
  easeOutElastic: (t) => A(t) ? t : it(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return A(t) ? t : t < 0.5 ? 0.5 * rt(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * it(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let n = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((n *= 1.525) + 1) * t - n)) : 0.5 * ((t -= 2) * t * (((n *= 1.525) + 1) * t + n) + 2);
  },
  easeInBounce: (t) => 1 - K.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? K.easeInBounce(t * 2) * 0.5 : K.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function U(t) {
  if (t && typeof t == "object") {
    const n = t.toString();
    return n === "[object CanvasPattern]" || n === "[object CanvasGradient]";
  }
  return !1;
}
function Se(t) {
  return U(t) ? t : new pt(t);
}
function V(t) {
  return U(t) ? t : new pt(t).saturate(0.5).darken(0.1).hexString();
}
const Kt = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Vt = [
  "color",
  "borderColor",
  "backgroundColor"
];
function Gt(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (n) => n !== "onProgress" && n !== "onComplete" && n !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: Vt
    },
    numbers: {
      type: "number",
      properties: Kt
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (n) => n | 0
        }
      }
    }
  });
}
function Jt(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const at = /* @__PURE__ */ new Map();
function Ut(t, n) {
  n = n || {};
  const e = t + JSON.stringify(n);
  let o = at.get(e);
  return o || (o = new Intl.NumberFormat(t, n), at.set(e, o)), o;
}
function Xt(t, n, e) {
  return Ut(n, e).format(t);
}
const Yt = {
  values(t) {
    return P(t) ? t : "" + t;
  },
  numeric(t, n, e) {
    if (t === 0)
      return "0";
    const o = this.chart.options.locale;
    let r, i = t;
    if (e.length > 1) {
      const l = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (l < 1e-4 || l > 1e15) && (r = "scientific"), i = Zt(t, e);
    }
    const a = bt(Math.abs(i)), s = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), c = {
      notation: r,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(c, this.options.ticks.format), Xt(t, o, c);
  }
};
function Zt(t, n) {
  let e = n.length > 3 ? n[2].value - n[1].value : n[1].value - n[0].value;
  return Math.abs(e) >= 1 && t !== Math.floor(t) && (e = t - Math.floor(t)), e;
}
var tn = {
  formatters: Yt
};
function nn(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (n, e) => e.lineWidth,
      tickColor: (n, e) => e.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: tn.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (n) => !n.startsWith("before") && !n.startsWith("after") && n !== "callback" && n !== "parser",
    _indexable: (n) => n !== "borderDash" && n !== "tickBorderDash" && n !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (n) => n !== "backdropPadding" && n !== "callback",
    _indexable: (n) => n !== "backdropPadding"
  });
}
const en = /* @__PURE__ */ Object.create(null), on = /* @__PURE__ */ Object.create(null);
function W(t, n) {
  if (!n)
    return t;
  const e = n.split(".");
  for (let o = 0, r = e.length; o < r; ++o) {
    const i = e[o];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function G(t, n, e) {
  return typeof n == "string" ? E(W(t, n), e) : E(W(t, ""), n);
}
class rn {
  constructor(n, e) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (o) => o.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (o, r) => V(r.backgroundColor), this.hoverBorderColor = (o, r) => V(r.borderColor), this.hoverColor = (o, r) => V(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(n), this.apply(e);
  }
  set(n, e) {
    return G(this, n, e);
  }
  get(n) {
    return W(this, n);
  }
  describe(n, e) {
    return G(on, n, e);
  }
  override(n, e) {
    return G(en, n, e);
  }
  route(n, e, o, r) {
    const i = W(this, n), a = W(this, o), s = "_" + e;
    Object.defineProperties(i, {
      [s]: {
        value: i[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const c = this[s], l = a[r];
          return x(c) ? Object.assign({}, l, c) : _(c, l);
        },
        set(c) {
          this[s] = c;
        }
      }
    });
  }
  apply(n) {
    n.forEach((e) => e(this));
  }
}
var an = /* @__PURE__ */ new rn({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  Gt,
  Jt,
  nn
]);
function sn(t) {
  return !t || I(t.size) || I(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function Ce(t, n, e, o, r) {
  let i = n[r];
  return i || (i = n[r] = t.measureText(r).width, e.push(r)), i > o && (o = i), o;
}
function Ie(t, n, e) {
  const o = t.currentDevicePixelRatio, r = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((n - r) * o) / o + r;
}
function je(t, n) {
  !n && !t || (n = n || t.getContext("2d"), n.save(), n.resetTransform(), n.clearRect(0, 0, t.width, t.height), n.restore());
}
function Re(t, n, e, o) {
  cn(t, n, e, o, null);
}
function cn(t, n, e, o, r) {
  let i, a, s, c, l, u, p, d;
  const g = n.pointStyle, y = n.rotation, h = n.radius;
  let f = (y || 0) * Et;
  if (g && typeof g == "object" && (i = g.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(e, o), t.rotate(f), t.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), t.restore();
    return;
  }
  if (!(isNaN(h) || h <= 0)) {
    switch (t.beginPath(), g) {
      // Default includes circle
      default:
        r ? t.ellipse(e, o, r / 2, h, 0, 0, M) : t.arc(e, o, h, 0, M), t.closePath();
        break;
      case "triangle":
        u = r ? r / 2 : h, t.moveTo(e + Math.sin(f) * u, o - Math.cos(f) * h), f += nt, t.lineTo(e + Math.sin(f) * u, o - Math.cos(f) * h), f += nt, t.lineTo(e + Math.sin(f) * u, o - Math.cos(f) * h), t.closePath();
        break;
      case "rectRounded":
        l = h * 0.516, c = h - l, a = Math.cos(f + k) * c, p = Math.cos(f + k) * (r ? r / 2 - l : c), s = Math.sin(f + k) * c, d = Math.sin(f + k) * (r ? r / 2 - l : c), t.arc(e - p, o - s, l, f - m, f - w), t.arc(e + d, o - a, l, f - w, f), t.arc(e + p, o + s, l, f, f + w), t.arc(e - d, o + a, l, f + w, f + m), t.closePath();
        break;
      case "rect":
        if (!y) {
          c = Math.SQRT1_2 * h, u = r ? r / 2 : c, t.rect(e - u, o - c, 2 * u, 2 * c);
          break;
        }
        f += k;
      /* falls through */
      case "rectRot":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), t.moveTo(e - p, o - s), t.lineTo(e + d, o - a), t.lineTo(e + p, o + s), t.lineTo(e - d, o + a), t.closePath();
        break;
      case "crossRot":
        f += k;
      /* falls through */
      case "cross":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), t.moveTo(e - p, o - s), t.lineTo(e + p, o + s), t.moveTo(e + d, o - a), t.lineTo(e - d, o + a);
        break;
      case "star":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), t.moveTo(e - p, o - s), t.lineTo(e + p, o + s), t.moveTo(e + d, o - a), t.lineTo(e - d, o + a), f += k, p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), t.moveTo(e - p, o - s), t.lineTo(e + p, o + s), t.moveTo(e + d, o - a), t.lineTo(e - d, o + a);
        break;
      case "line":
        a = r ? r / 2 : Math.cos(f) * h, s = Math.sin(f) * h, t.moveTo(e - a, o - s), t.lineTo(e + a, o + s);
        break;
      case "dash":
        t.moveTo(e, o), t.lineTo(e + Math.cos(f) * (r ? r / 2 : h), o + Math.sin(f) * h);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), n.borderWidth > 0 && t.stroke();
  }
}
function st(t, n, e) {
  return e = e || 0.5, !n || t && t.x > n.left - e && t.x < n.right + e && t.y > n.top - e && t.y < n.bottom + e;
}
function We(t, n) {
  t.save(), t.beginPath(), t.rect(n.left, n.top, n.right - n.left, n.bottom - n.top), t.clip();
}
function Be(t) {
  t.restore();
}
function Ae(t, n, e, o, r) {
  if (!n)
    return t.lineTo(e.x, e.y);
  if (r === "middle") {
    const i = (n.x + e.x) / 2;
    t.lineTo(i, n.y), t.lineTo(i, e.y);
  } else r === "after" != !!o ? t.lineTo(n.x, e.y) : t.lineTo(e.x, n.y);
  t.lineTo(e.x, e.y);
}
function De(t, n, e, o) {
  if (!n)
    return t.lineTo(e.x, e.y);
  t.bezierCurveTo(o ? n.cp1x : n.cp2x, o ? n.cp1y : n.cp2y, o ? e.cp2x : e.cp1x, o ? e.cp2y : e.cp1y, e.x, e.y);
}
function ln(t, n) {
  n.translation && t.translate(n.translation[0], n.translation[1]), I(n.rotation) || t.rotate(n.rotation), n.color && (t.fillStyle = n.color), n.textAlign && (t.textAlign = n.textAlign), n.textBaseline && (t.textBaseline = n.textBaseline);
}
function un(t, n, e, o, r) {
  if (r.strikethrough || r.underline) {
    const i = t.measureText(o), a = n - i.actualBoundingBoxLeft, s = n + i.actualBoundingBoxRight, c = e - i.actualBoundingBoxAscent, l = e + i.actualBoundingBoxDescent, u = r.strikethrough ? (c + l) / 2 : l;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = r.decorationWidth || 2, t.moveTo(a, u), t.lineTo(s, u), t.stroke();
  }
}
function fn(t, n) {
  const e = t.fillStyle;
  t.fillStyle = n.color, t.fillRect(n.left, n.top, n.width, n.height), t.fillStyle = e;
}
function Ne(t, n, e, o, r, i = {}) {
  const a = P(n) ? n : [
    n
  ], s = i.strokeWidth > 0 && i.strokeColor !== "";
  let c, l;
  for (t.save(), t.font = r.string, ln(t, i), c = 0; c < a.length; ++c)
    l = a[c], i.backdrop && fn(t, i.backdrop), s && (i.strokeColor && (t.strokeStyle = i.strokeColor), I(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(l, e, o, i.maxWidth)), t.fillText(l, e, o, i.maxWidth), un(t, e, o, l, i), o += Number(r.lineHeight);
  t.restore();
}
function Le(t, n) {
  const { x: e, y: o, w: r, h: i, radius: a } = n;
  t.arc(e + a.topLeft, o + a.topLeft, a.topLeft, 1.5 * m, m, !0), t.lineTo(e, o + i - a.bottomLeft), t.arc(e + a.bottomLeft, o + i - a.bottomLeft, a.bottomLeft, m, w, !0), t.lineTo(e + r - a.bottomRight, o + i), t.arc(e + r - a.bottomRight, o + i - a.bottomRight, a.bottomRight, w, 0, !0), t.lineTo(e + r, o + a.topRight), t.arc(e + r - a.topRight, o + a.topRight, a.topRight, 0, -w, !0), t.lineTo(e + a.topLeft, o);
}
const hn = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, pn = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function dn(t, n) {
  const e = ("" + t).match(hn);
  if (!e || e[1] === "normal")
    return n * 1.2;
  switch (t = +e[2], e[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return n * t;
}
const gn = (t) => +t || 0;
function wt(t, n) {
  const e = {}, o = x(n), r = o ? Object.keys(n) : n, i = x(t) ? o ? (a) => _(t[a], t[n[a]]) : (a) => t[a] : () => t;
  for (const a of r)
    e[a] = gn(i(a));
  return e;
}
function yn(t) {
  return wt(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function ze(t) {
  return wt(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Ee(t) {
  const n = yn(t);
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
function He(t, n) {
  t = t || {}, n = n || an.font;
  let e = _(t.size, n.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let o = _(t.style, n.style);
  o && !("" + o).match(pn) && (console.warn('Invalid font style specified: "' + o + '"'), o = void 0);
  const r = {
    family: _(t.family, n.family),
    lineHeight: dn(_(t.lineHeight, n.lineHeight), e),
    size: e,
    style: o,
    weight: _(t.weight, n.weight),
    string: ""
  };
  return r.string = sn(r), r;
}
function Fe(t, n, e, o) {
  let r, i, a;
  for (r = 0, i = t.length; r < i; ++r)
    if (a = t[r], a !== void 0 && a !== void 0)
      return a;
}
function Qe(t, n, e) {
  const { min: o, max: r } = t, i = Rt(n, (r - o) / 2), a = (s, c) => e && s === 0 ? 0 : s + c;
  return {
    min: a(o, -Math.abs(i)),
    max: a(r, i)
  };
}
function bn(t, n) {
  return Object.assign(Object.create(t), n);
}
function vt(t, n = [
  ""
], e, o, r = () => t[0]) {
  const i = e || t;
  typeof o > "u" && (o = Ot("_fallback", t));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: o,
    _getTarget: r,
    override: (s) => vt([
      s,
      ...t
    ], n, i, o)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, c) {
      return delete s[c], delete s._keys, delete t[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, c) {
      return kt(s, c, () => Pn(c, n, t, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, c) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(s, c) {
      return lt(s).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(s) {
      return lt(s);
    },
    /**
    * A trap for setting property values.
    */
    set(s, c, l) {
      const u = s._storage || (s._storage = r());
      return s[c] = u[c] = l, delete s._keys, !0;
    }
  });
}
function Q(t, n, e, o) {
  const r = {
    _cacheable: !1,
    _proxy: t,
    _context: n,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: mn(t, o),
    setContext: (i) => Q(t, i, e, o),
    override: (i) => Q(t.override(i), n, e, o)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, a) {
      return delete i[a], delete t[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, a, s) {
      return kt(i, a, () => Mn(i, a, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, a) {
      return i._descriptors.allKeys ? Reflect.has(t, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, a) {
      return Reflect.has(t, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, a, s) {
      return t[a] = s, delete i[a], !0;
    }
  });
}
function mn(t, n = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: e = n.scriptable, _indexable: o = n.indexable, _allKeys: r = n.allKeys } = t;
  return {
    allKeys: r,
    scriptable: e,
    indexable: o,
    isScriptable: H(e) ? e : () => e,
    isIndexable: H(o) ? o : () => o
  };
}
const xn = (t, n) => t ? t + yt(n) : n, X = (t, n) => x(n) && t !== "adapters" && (Object.getPrototypeOf(n) === null || n.constructor === Object);
function kt(t, n, e) {
  if (Object.prototype.hasOwnProperty.call(t, n) || n === "constructor")
    return t[n];
  const o = e();
  return t[n] = o, o;
}
function Mn(t, n, e) {
  const { _proxy: o, _context: r, _subProxy: i, _descriptors: a } = t;
  let s = o[n];
  return H(s) && a.isScriptable(n) && (s = wn(n, s, t, e)), P(s) && s.length && (s = vn(n, s, t, a.isIndexable)), X(n, s) && (s = Q(s, r, i && i[n], a)), s;
}
function wn(t, n, e, o) {
  const { _proxy: r, _context: i, _subProxy: a, _stack: s } = e;
  if (s.has(t))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + t);
  s.add(t);
  let c = n(i, a || o);
  return s.delete(t), X(t, c) && (c = Y(r._scopes, r, t, c)), c;
}
function vn(t, n, e, o) {
  const { _proxy: r, _context: i, _subProxy: a, _descriptors: s } = e;
  if (typeof i.index < "u" && o(t))
    return n[i.index % n.length];
  if (x(n[0])) {
    const c = n, l = r._scopes.filter((u) => u !== c);
    n = [];
    for (const u of c) {
      const p = Y(l, r, t, u);
      n.push(Q(p, i, a && a[t], s));
    }
  }
  return n;
}
function _t(t, n, e) {
  return H(t) ? t(n, e) : t;
}
const kn = (t, n) => t === !0 ? n : typeof t == "string" ? Lt(n, t) : void 0;
function _n(t, n, e, o, r) {
  for (const i of n) {
    const a = kn(e, i);
    if (a) {
      t.add(a);
      const s = _t(a._fallback, e, r);
      if (typeof s < "u" && s !== e && s !== o)
        return s;
    } else if (a === !1 && typeof o < "u" && e !== o)
      return null;
  }
  return !1;
}
function Y(t, n, e, o) {
  const r = n._rootScopes, i = _t(n._fallback, e, o), a = [
    ...t,
    ...r
  ], s = /* @__PURE__ */ new Set();
  s.add(o);
  let c = ct(s, a, e, i || e, o);
  return c === null || typeof i < "u" && i !== e && (c = ct(s, a, i, c, o), c === null) ? !1 : vt(Array.from(s), [
    ""
  ], r, i, () => On(n, e, o));
}
function ct(t, n, e, o, r) {
  for (; e; )
    e = _n(t, n, e, o, r);
  return e;
}
function On(t, n, e) {
  const o = t._getTarget();
  n in o || (o[n] = {});
  const r = o[n];
  return P(r) && x(e) ? e : r || {};
}
function Pn(t, n, e, o) {
  let r;
  for (const i of n)
    if (r = Ot(xn(i, t), e), typeof r < "u")
      return X(t, r) ? Y(e, o, t, r) : r;
}
function Ot(t, n) {
  for (const e of n) {
    if (!e)
      continue;
    const o = e[t];
    if (typeof o < "u")
      return o;
  }
}
function lt(t) {
  let n = t._keys;
  return n || (n = t._keys = Tn(t._scopes)), n;
}
function Tn(t) {
  const n = /* @__PURE__ */ new Set();
  for (const e of t)
    for (const o of Object.keys(e).filter((r) => !r.startsWith("_")))
      n.add(o);
  return Array.from(n);
}
const Sn = Number.EPSILON || 1e-14, j = (t, n) => n < t.length && !t[n].skip && t[n], Pt = (t) => t === "x" ? "y" : "x";
function Cn(t, n, e, o) {
  const r = t.skip ? n : t, i = n, a = e.skip ? n : e, s = ot(i, r), c = ot(a, i);
  let l = s / (s + c), u = c / (s + c);
  l = isNaN(l) ? 0 : l, u = isNaN(u) ? 0 : u;
  const p = o * l, d = o * u;
  return {
    previous: {
      x: i.x - p * (a.x - r.x),
      y: i.y - p * (a.y - r.y)
    },
    next: {
      x: i.x + d * (a.x - r.x),
      y: i.y + d * (a.y - r.y)
    }
  };
}
function In(t, n, e) {
  const o = t.length;
  let r, i, a, s, c, l = j(t, 0);
  for (let u = 0; u < o - 1; ++u)
    if (c = l, l = j(t, u + 1), !(!c || !l)) {
      if (mt(n[u], 0, Sn)) {
        e[u] = e[u + 1] = 0;
        continue;
      }
      r = e[u] / n[u], i = e[u + 1] / n[u], s = Math.pow(r, 2) + Math.pow(i, 2), !(s <= 9) && (a = 3 / Math.sqrt(s), e[u] = r * a * n[u], e[u + 1] = i * a * n[u]);
    }
}
function jn(t, n, e = "x") {
  const o = Pt(e), r = t.length;
  let i, a, s, c = j(t, 0);
  for (let l = 0; l < r; ++l) {
    if (a = s, s = c, c = j(t, l + 1), !s)
      continue;
    const u = s[e], p = s[o];
    a && (i = (u - a[e]) / 3, s[`cp1${e}`] = u - i, s[`cp1${o}`] = p - i * n[l]), c && (i = (c[e] - u) / 3, s[`cp2${e}`] = u + i, s[`cp2${o}`] = p + i * n[l]);
  }
}
function Rn(t, n = "x") {
  const e = Pt(n), o = t.length, r = Array(o).fill(0), i = Array(o);
  let a, s, c, l = j(t, 0);
  for (a = 0; a < o; ++a)
    if (s = c, c = l, l = j(t, a + 1), !!c) {
      if (l) {
        const u = l[n] - c[n];
        r[a] = u !== 0 ? (l[e] - c[e]) / u : 0;
      }
      i[a] = s ? l ? et(r[a - 1]) !== et(r[a]) ? 0 : (r[a - 1] + r[a]) / 2 : r[a - 1] : r[a];
    }
  In(t, r, i), jn(t, i, n);
}
function D(t, n, e) {
  return Math.max(Math.min(t, e), n);
}
function Wn(t, n) {
  let e, o, r, i, a, s = st(t[0], n);
  for (e = 0, o = t.length; e < o; ++e)
    a = i, i = s, s = e < o - 1 && st(t[e + 1], n), i && (r = t[e], a && (r.cp1x = D(r.cp1x, n.left, n.right), r.cp1y = D(r.cp1y, n.top, n.bottom)), s && (r.cp2x = D(r.cp2x, n.left, n.right), r.cp2y = D(r.cp2y, n.top, n.bottom)));
}
function qe(t, n, e, o, r) {
  let i, a, s, c;
  if (n.spanGaps && (t = t.filter((l) => !l.skip)), n.cubicInterpolationMode === "monotone")
    Rn(t, r);
  else {
    let l = o ? t[t.length - 1] : t[0];
    for (i = 0, a = t.length; i < a; ++i)
      s = t[i], c = Cn(l, s, t[Math.min(i + 1, a - (o ? 0 : 1)) % a], n.tension), s.cp1x = c.previous.x, s.cp1y = c.previous.y, s.cp2x = c.next.x, s.cp2y = c.next.y, l = s;
  }
  n.capBezierPoints && Wn(t, e);
}
function Bn() {
  return typeof window < "u" && typeof document < "u";
}
function An(t) {
  let n = t.parentNode;
  return n && n.toString() === "[object ShadowRoot]" && (n = n.host), n;
}
function q(t, n, e) {
  let o;
  return typeof t == "string" ? (o = parseInt(t, 10), t.indexOf("%") !== -1 && (o = o / 100 * n.parentNode[e])) : o = t, o;
}
const $ = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function Dn(t, n) {
  return $(t).getPropertyValue(n);
}
const Nn = [
  "top",
  "right",
  "bottom",
  "left"
];
function O(t, n, e) {
  const o = {};
  e = e ? "-" + e : "";
  for (let r = 0; r < 4; r++) {
    const i = Nn[r];
    o[i] = parseFloat(t[n + "-" + i + e]) || 0;
  }
  return o.width = o.left + o.right, o.height = o.top + o.bottom, o;
}
const Ln = (t, n, e) => (t > 0 || n > 0) && (!e || !e.shadowRoot);
function zn(t, n) {
  const e = t.touches, o = e && e.length ? e[0] : t, { offsetX: r, offsetY: i } = o;
  let a = !1, s, c;
  if (Ln(r, i, t.target))
    s = r, c = i;
  else {
    const l = n.getBoundingClientRect();
    s = o.clientX - l.left, c = o.clientY - l.top, a = !0;
  }
  return {
    x: s,
    y: c,
    box: a
  };
}
function $e(t, n) {
  if ("native" in t)
    return t;
  const { canvas: e, currentDevicePixelRatio: o } = n, r = $(e), i = r.boxSizing === "border-box", a = O(r, "padding"), s = O(r, "border", "width"), { x: c, y: l, box: u } = zn(t, e), p = a.left + (u && s.left), d = a.top + (u && s.top);
  let { width: g, height: y } = n;
  return i && (g -= a.width + s.width, y -= a.height + s.height), {
    x: Math.round((c - p) / g * e.width / o),
    y: Math.round((l - d) / y * e.height / o)
  };
}
function En(t, n, e) {
  let o, r;
  if (n === void 0 || e === void 0) {
    const i = t && An(t);
    if (!i)
      n = t.clientWidth, e = t.clientHeight;
    else {
      const a = i.getBoundingClientRect(), s = $(i), c = O(s, "border", "width"), l = O(s, "padding");
      n = a.width - l.width - c.width, e = a.height - l.height - c.height, o = q(s.maxWidth, i, "clientWidth"), r = q(s.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: n,
    height: e,
    maxWidth: o || F,
    maxHeight: r || F
  };
}
const N = (t) => Math.round(t * 10) / 10;
function Ke(t, n, e, o) {
  const r = $(t), i = O(r, "margin"), a = q(r.maxWidth, t, "clientWidth") || F, s = q(r.maxHeight, t, "clientHeight") || F, c = En(t, n, e);
  let { width: l, height: u } = c;
  if (r.boxSizing === "content-box") {
    const p = O(r, "border", "width"), d = O(r, "padding");
    l -= d.width + p.width, u -= d.height + p.height;
  }
  return l = Math.max(0, l - i.width), u = Math.max(0, o ? l / o : u - i.height), l = N(Math.min(l, a, c.maxWidth)), u = N(Math.min(u, s, c.maxHeight)), l && !u && (u = N(l / 2)), (n !== void 0 || e !== void 0) && o && c.height && u > c.height && (u = c.height, l = N(Math.floor(u * o))), {
    width: l,
    height: u
  };
}
function Ve(t, n, e) {
  const o = n || 1, r = Math.floor(t.height * o), i = Math.floor(t.width * o);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const a = t.canvas;
  return a.style && (e || !a.style.height && !a.style.width) && (a.style.height = `${t.height}px`, a.style.width = `${t.width}px`), t.currentDevicePixelRatio !== o || a.height !== r || a.width !== i ? (t.currentDevicePixelRatio = o, a.height = r, a.width = i, t.ctx.setTransform(o, 0, 0, o, 0, 0), !0) : !1;
}
const Ge = (function() {
  let t = !1;
  try {
    const n = {
      get passive() {
        return t = !0, !1;
      }
    };
    Bn() && (window.addEventListener("test", null, n), window.removeEventListener("test", null, n));
  } catch {
  }
  return t;
})();
function Je(t, n) {
  const e = Dn(t, n), o = e && e.match(/^(\d+)(\.\d+)?px$/);
  return o ? +o[1] : void 0;
}
function C(t, n, e, o) {
  return {
    x: t.x + e * (n.x - t.x),
    y: t.y + e * (n.y - t.y)
  };
}
function Ue(t, n, e, o) {
  return {
    x: t.x + e * (n.x - t.x),
    y: o === "middle" ? e < 0.5 ? t.y : n.y : o === "after" ? e < 1 ? t.y : n.y : e > 0 ? n.y : t.y
  };
}
function Xe(t, n, e, o) {
  const r = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: n.cp1x,
    y: n.cp1y
  }, a = C(t, r, e), s = C(r, i, e), c = C(i, n, e), l = C(a, s, e), u = C(s, c, e);
  return C(l, u, e);
}
const Hn = function(t, n) {
  return {
    x(e) {
      return t + t + n - e;
    },
    setWidth(e) {
      n = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, o) {
      return e - o;
    },
    leftForLtr(e, o) {
      return e - o;
    }
  };
}, Fn = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, n) {
      return t + n;
    },
    leftForLtr(t, n) {
      return t;
    }
  };
};
function Ye(t, n, e) {
  return t ? Hn(n, e) : Fn();
}
function Ze(t, n) {
  let e, o;
  (n === "ltr" || n === "rtl") && (e = t.canvas.style, o = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", n, "important"), t.prevTextDirection = o);
}
function to(t, n) {
  n !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", n[0], n[1]));
}
function Tt(t) {
  return t === "angle" ? {
    between: Qt,
    compare: Ft,
    normalize: v
  } : {
    between: qt,
    compare: (n, e) => n - e,
    normalize: (n) => n
  };
}
function ut({ start: t, end: n, count: e, loop: o, style: r }) {
  return {
    start: t % e,
    end: n % e,
    loop: o && (n - t + 1) % e === 0,
    style: r
  };
}
function Qn(t, n, e) {
  const { property: o, start: r, end: i } = e, { between: a, normalize: s } = Tt(o), c = n.length;
  let { start: l, end: u, loop: p } = t, d, g;
  if (p) {
    for (l += c, u += c, d = 0, g = c; d < g && a(s(n[l % c][o]), r, i); ++d)
      l--, u--;
    l %= c, u %= c;
  }
  return u < l && (u += c), {
    start: l,
    end: u,
    loop: p,
    style: t.style
  };
}
function qn(t, n, e) {
  if (!e)
    return [
      t
    ];
  const { property: o, start: r, end: i } = e, a = n.length, { compare: s, between: c, normalize: l } = Tt(o), { start: u, end: p, loop: d, style: g } = Qn(t, n, e), y = [];
  let h = !1, f = null, b, T, R;
  const St = () => c(r, R, b) && s(r, R) !== 0, Ct = () => s(i, b) === 0 || c(i, R, b), It = () => h || St(), jt = () => !h || Ct();
  for (let S = u, Z = u; S <= p; ++S)
    T = n[S % a], !T.skip && (b = l(T[o]), b !== R && (h = c(b, r, i), f === null && It() && (f = s(b, r) === 0 ? S : Z), f !== null && jt() && (y.push(ut({
      start: f,
      end: S,
      loop: d,
      count: a,
      style: g
    })), f = null), Z = S, R = b));
  return f !== null && y.push(ut({
    start: f,
    end: p,
    loop: d,
    count: a,
    style: g
  })), y;
}
function no(t, n) {
  const e = [], o = t.segments;
  for (let r = 0; r < o.length; r++) {
    const i = qn(o[r], t.points, n);
    i.length && e.push(...i);
  }
  return e;
}
function $n(t, n, e, o) {
  let r = 0, i = n - 1;
  if (e && !o)
    for (; r < n && !t[r].skip; )
      r++;
  for (; r < n && t[r].skip; )
    r++;
  for (r %= n, e && (i += r); i > r && t[i % n].skip; )
    i--;
  return i %= n, {
    start: r,
    end: i
  };
}
function Kn(t, n, e, o) {
  const r = t.length, i = [];
  let a = n, s = t[n], c;
  for (c = n + 1; c <= e; ++c) {
    const l = t[c % r];
    l.skip || l.stop ? s.skip || (o = !1, i.push({
      start: n % r,
      end: (c - 1) % r,
      loop: o
    }), n = a = l.stop ? c : null) : (a = c, s.skip && (n = c)), s = l;
  }
  return a !== null && i.push({
    start: n % r,
    end: a % r,
    loop: o
  }), i;
}
function eo(t, n) {
  const e = t.points, o = t.options.spanGaps, r = e.length;
  if (!r)
    return [];
  const i = !!t._loop, { start: a, end: s } = $n(e, r, i, o);
  if (o === !0)
    return ft(t, [
      {
        start: a,
        end: s,
        loop: i
      }
    ], e, n);
  const c = s < a ? s + r : s, l = !!t._fullLoop && a === 0 && s === r - 1;
  return ft(t, Kn(e, a, c, l), e, n);
}
function ft(t, n, e, o) {
  return !o || !o.setContext || !e ? n : Vn(t, n, e, o);
}
function Vn(t, n, e, o) {
  const r = t._chart.getContext(), i = ht(t.options), { _datasetIndex: a, options: { spanGaps: s } } = t, c = e.length, l = [];
  let u = i, p = n[0].start, d = p;
  function g(y, h, f, b) {
    const T = s ? -1 : 1;
    if (y !== h) {
      for (y += c; e[y % c].skip; )
        y -= T;
      for (; e[h % c].skip; )
        h += T;
      y % c !== h % c && (l.push({
        start: y % c,
        end: h % c,
        loop: f,
        style: b
      }), u = b, p = h % c);
    }
  }
  for (const y of n) {
    p = s ? p : y.start;
    let h = e[p % c], f;
    for (d = p + 1; d <= y.end; d++) {
      const b = e[d % c];
      f = ht(o.setContext(bn(r, {
        type: "segment",
        p0: h,
        p1: b,
        p0DataIndex: (d - 1) % c,
        p1DataIndex: d % c,
        datasetIndex: a
      }))), Gn(f, u) && g(p, d - 1, y.loop, u), h = b, u = f;
    }
    p < d - 1 && g(p, d - 1, y.loop, u);
  }
  return l;
}
function ht(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function Gn(t, n) {
  if (!n)
    return !1;
  const e = [], o = function(r, i) {
    return U(i) ? (e.includes(i) || e.push(i), e.indexOf(i)) : i;
  };
  return JSON.stringify(t, o) !== JSON.stringify(n, o);
}
function L(t, n, e) {
  return t.options.clip ? t[e] : n[e];
}
function Jn(t, n) {
  const { xScale: e, yScale: o } = t;
  return e && o ? {
    left: L(e, n, "left"),
    right: L(e, n, "right"),
    top: L(o, n, "top"),
    bottom: L(o, n, "bottom")
  } : n;
}
function oo(t, n) {
  const e = n._clip;
  if (e.disabled)
    return !1;
  const o = Jn(n, t.chartArea);
  return {
    left: e.left === !1 ? 0 : o.left - (e.left === !0 ? 0 : e.left),
    right: e.right === !1 ? t.width : o.right + (e.right === !0 ? 0 : e.right),
    top: e.top === !1 ? 0 : o.top - (e.top === !0 ? 0 : e.top),
    bottom: e.bottom === !1 ? t.height : o.bottom + (e.bottom === !0 ? 0 : e.bottom)
  };
}
export {
  Be as $,
  be as A,
  B,
  st as C,
  ge as D,
  Ee as E,
  ee as F,
  Ke as G,
  w as H,
  An as I,
  Je as J,
  Ge as K,
  we as L,
  Bn as M,
  ce as N,
  Zn as O,
  m as P,
  ne as Q,
  Qe as R,
  J as S,
  M as T,
  pe as U,
  Ce as V,
  ye as W,
  Ie as X,
  We as Y,
  Ne as Z,
  Me as _,
  Fe as a,
  Dn as a$,
  He as a0,
  ke as a1,
  _e as a2,
  en as a3,
  E as a4,
  yt as a5,
  on as a6,
  H as a7,
  Q as a8,
  vt as a9,
  Ye as aA,
  Ze as aB,
  Oe as aC,
  to as aD,
  cn as aE,
  ot as aF,
  Xn as aG,
  fe as aH,
  se as aI,
  ue as aJ,
  mt as aK,
  de as aL,
  tn as aM,
  bt as aN,
  xt as aQ,
  U as aR,
  V as aS,
  z as aT,
  Wt as aU,
  At as aV,
  Dt as aX,
  sn as aY,
  Cn as aZ,
  Rn as a_,
  mn as aa,
  Bt as ab,
  Yn as ac,
  ve as ad,
  Ve as ae,
  je as af,
  ie as ag,
  oo as ah,
  oe as ai,
  ae as aj,
  qt as ak,
  v as al,
  wt as am,
  qe as an,
  eo as ao,
  no as ap,
  Ue as aq,
  Xe as ar,
  C as as,
  Ae as at,
  De as au,
  Re as av,
  Le as aw,
  yn as ax,
  ze as ay,
  qn as az,
  P as b,
  dn as b1,
  zt as b2,
  F as b3,
  Et as b4,
  k as b5,
  nt as b6,
  Ft as b7,
  Se as c,
  an as d,
  K as e,
  Lt as f,
  dt as g,
  re as h,
  x as i,
  bn as j,
  I as k,
  me as l,
  te as m,
  Rt as n,
  Xt as o,
  Qt as p,
  Pe as q,
  $t as r,
  et as s,
  he as t,
  xe as u,
  _ as v,
  Te as w,
  le as x,
  $e as z
};
//# sourceMappingURL=index.es136.js.map
